var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.69792 0 5.83333 1.86563 5.83333 4.16667C5.83333 5.84653 6.41875 6.31597 9.57292 10.8854C9.77976 11.1842 10.2219 11.1842 10.4288 10.8854C13.5799 6.31597 14.1667 5.84722 14.1667 4.16667C14.1667 1.86563 12.3021 0 10 0ZM10 6.11111C9.07986 6.11111 8.33333 5.36458 8.33333 4.44444C8.33333 3.52431 9.07986 2.77778 10 2.77778C10.9194 2.77778 11.6667 3.52535 11.6667 4.44444C11.6667 5.36354 10.9201 6.11111 10 6.11111ZM0.349306 7.90278C0.138333 7.98611 0 8.19097 0 8.41667V17.2187C0 17.6118 0.398958 17.8799 0.763889 17.734L5.55556 15.5556V6.99305C5.29514 6.55555 5.11111 6.18056 4.97917 5.81597L0.349306 7.90278ZM11.3403 11.5208C11.0382 11.9583 10.5347 12.2222 10 12.2222C9.46458 12.2222 8.96319 11.9595 8.65764 11.5181C8.09722 10.7049 6.83681 8.90972 6.66667 8.66667V15.5243L13.3333 17.7778V8.66667C13.1632 8.90972 11.9028 10.7049 11.3403 11.5208ZM19.2396 5.59722L14.4444 7.77778V17.7778L19.6493 15.4309C19.8611 15.316 20 15.1424 20 14.9167V6.11111C20 5.71875 19.6042 5.42014 19.2396 5.59722Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.85c8faf1.svg";
export { ForwardRef as ReactComponent };